import React, { useMemo } from "react";
import Popup from "reactjs-popup";
import { PopupProps } from "reactjs-popup/dist/types";

import "./CommentAudiences.styles.scss";
import { ReactComponent as ArrowBackIcon } from "../../../assets/icons/chevron-down-light-green.svg";
import { ReactComponent as GroupIcon } from "../../../assets/icons/group.svg";
import { useAudiencesSelector, useUserRoleSelector } from "../../../store";
import { IAudiences, IRole, KeyOfAudiences } from "../../../store/types";
import { isRoleAnalyst } from "../../../utils/user";
import { AudienceIcon } from "../../Comments/Audience-icon/AudienceIcon";

export interface CommentAudienceProps extends Partial<PopupProps> {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  onItemClick: (value: KeyOfAudiences) => void;
  selectedAudience: KeyOfAudiences;
  showTriggerTitle?: boolean;
}

export const CommentAudience: React.FC<CommentAudienceProps> = ({
  isOpen,
  setIsOpen,
  onItemClick,
  selectedAudience,
  showTriggerTitle = false,
  ...props
}) => {
  const audiences: IAudiences = useAudiencesSelector();
  const role: IRole | null = useUserRoleSelector();

  type AudiencesObjType = {
    label: string;
    key: KeyOfAudiences;
  };

  const audiencesObjects: AudiencesObjType[] = useMemo(() => {
    return (Object.keys(audiences) as KeyOfAudiences[]).reduce((acc: AudiencesObjType[], item: KeyOfAudiences) => {
      return [...acc, { label: audiences[item], key: item }];
    }, []);
  }, [audiences]);

  return (
    <Popup
      repositionOnResize
      keepTooltipInside
      className="audience-popup"
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      trigger={
        <div className="audience-popup__trigger flex-row-fs-fc">
          {selectedAudience ? <AudienceIcon type={selectedAudience} /> : <GroupIcon />}
          {showTriggerTitle && <span>{selectedAudience ? audiences[selectedAudience] : audiences.everyone}</span>}
        </div>
      }
      {...props}
    >
      <div className={"comment-recipients opacity-appearance"}>
        <div className="comment-recipients__header flex-row-fc-fc">
          <ArrowBackIcon
            className="comment-recipients__header-icon"
            onClick={() => setIsOpen(false)}
            style={{ transform: "rotate(90deg)" }}
          />
          <span className="comment-recipients__title">Who can see the comment & the replies?</span>
        </div>
        <div className="comment-recipients__body">
          {audiencesObjects.map((audience: AudiencesObjType, index: number) => {
            if (
              !isRoleAnalyst({ role }) &&
              (audience.key === "everyone" ||
                audience.key === "capital_seeker" ||
                audience.key === "guest" ||
                audience.key === "viewer")
            )
              return null;
            return (
              <div
                className="comment-recipients__role flex-row-fc-fc"
                key={index + audience.key}
                onClick={() => {
                  onItemClick(audience.key);
                  setIsOpen(false);
                }}
              >
                <AudienceIcon type={audience.key} />
                <span>{audience.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </Popup>
  );
};
